"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeRecorderModeMenuSignaling = exports.resolveWorstMenuAlarmSample = exports.createMenuAlarmSample = void 0;
const utils_1 = require("../utils");
const createMenuAlarmSample = (alarmStatus, date, dbTz) => {
    if (!date || !Number.isFinite(alarmStatus)) {
        return null;
    }
    const timestamp = (0, utils_1.toFakeUtc)(date, dbTz).getTime();
    if (Number.isNaN(timestamp)) {
        return null;
    }
    return { alarmStatus, date, timestamp };
};
exports.createMenuAlarmSample = createMenuAlarmSample;
const resolveWorstMenuAlarmSample = (samples, windowStart) => {
    const samplesInWindow = samples.filter(sample => sample.timestamp >= windowStart);
    let worst = null;
    for (const sample of samplesInWindow) {
        if (!worst ||
            sample.alarmStatus > worst.alarmStatus ||
            (sample.alarmStatus === worst.alarmStatus && sample.timestamp > worst.timestamp)) {
            worst = sample;
        }
    }
    return { samples: samplesInWindow, worst };
};
exports.resolveWorstMenuAlarmSample = resolveWorstMenuAlarmSample;
const resolveRecorderModeTrain = (target, source, windowStart, dbTz) => {
    if (source.ldd != null) {
        return source;
    }
    if (target.ldd && (0, utils_1.toFakeUtc)(target.ldd, dbTz).getTime() >= new Date(windowStart).getTime()) {
        return target;
    }
    return source;
};
const mergeRecorderModeMenuSignaling = (existing, incoming, windowStart, dbTz, applySignalingToTrain) => {
    var _a;
    const trainsById = new Map();
    for (const station of incoming) {
        for (const train of station.Trains) {
            if (train.TrainId) {
                trainsById.set(train.TrainId, train);
            }
        }
    }
    let changed = false;
    for (const station of existing) {
        for (const train of station.Trains) {
            if (!train.TrainId) {
                continue;
            }
            const sourceTrain = trainsById.get(train.TrainId);
            if (!sourceTrain) {
                continue;
            }
            const resolvedTrain = resolveRecorderModeTrain(train, sourceTrain, windowStart, dbTz);
            if (applySignalingToTrain(train, resolvedTrain)) {
                changed = true;
            }
            train.ldd = (_a = resolvedTrain.ldd) !== null && _a !== void 0 ? _a : null;
        }
    }
    return changed;
};
exports.mergeRecorderModeMenuSignaling = mergeRecorderModeMenuSignaling;
//# sourceMappingURL=mergeMenuSignaling.js.map